import { ThemeProvider as MyThemeProvider } from '@lune/theme/context'
import React from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import { DashboardProvider } from './components/dashboard/context'

const container = document.getElementById('root')
if (container === null) {
  throw new Error("Can't create application container")
}
const root = createRoot(container)

root.render(
  <React.StrictMode>
    <MyThemeProvider>
      <DashboardProvider>
        <App />
      </DashboardProvider>
    </MyThemeProvider>
  </React.StrictMode>
)
